export default __webpack_public_path__ + "static/media/cobra.74a0ee9d.svg";